import "antd/dist/antd.css";
import {
  Input,
  FormControl,
  FormErrorMessage,
  Flex,
  Spacer,
  Box,
  SimpleGrid,
  Button,
  Textarea,
  Text,
} from "@chakra-ui/react";
import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import Parse from "parse";
import { useNavigate } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import ShowEvent from "../ShowEvent.jsx";
import UploadImage from "../UploadImage.jsx";
import SearchLocationInput from "../SearchLocationInput.jsx";
import moment from "moment-with-locales-es6";
import { Grid, Select } from "@mantine/core";
import "./AddEvent.css";

export const AddEvent = ({ show, title }) => {
  const navigate = useNavigate();
  const event_type = ["Coaching"];
  const work_domaine = [
    "Agriculture",
    "Commerce",
    "Communication",
    "Informatique",
    "Cuisine",
    "Transport",
    "Etudes et conseils",
    "Logistique/Transports",
    "Banque/Assurance",
    "Service aux entreprise",
  ];

  const [nomEvent, setNomEvent] = useState("");
  const [typeEvent, setTypeEvent] = useState("");
  const [secteur, setSecteurEvent] = useState("");
  const [description, setDescriptionEvent] = useState("");
  const [adresseEntreprise, setAdresseEntreprise] = useState("");
  const [dateDebut, setDateDebut] = useState("");
  const [startDate, setStartDate] = useState(new Date());
  const [dateFin, setDateFin] = useState("");
  const [endDate, setEndDate] = useState(new Date());
  const [duration, setDurationEvent] = useState("");
  const [maxPlace, setMaxPlace] = useState();

  const [prix, setPrixEvent] = useState("");
  const [imageFile, setImageFile] = useState();

  const [adress, setAddress] = useState();
  const [coords, setCoords] = useState({ lat: null, lng: null });

  const [eAdress, setEAddress] = useState();
  const [eNomEvent, setENomEvent] = useState(false);
  const [eTypeEvent, setETypeEvent] = useState(false);
  const [eSecteurEvent, setESecteurEvent] = useState(false);
  const [eDescriptionEvent, setEDescriptionEvent] = useState(false);
  const [eDateDebut, setEDateDebut] = useState(false);
  const [eDateFin, setEDateFin] = useState(false);
  const [eDurationEvent, setEDurationEvent] = useState(false);
  const [ePrixEvent, setEPrixEvent] = useState(false);
  const [eMaxPlace, setEMaxPlace] = useState();

  const getCoords = (latlng) => {
    setCoords(latlng);
  };
  const getAddress = (adr) => {
    setAddress(adr);
    setAdresseEntreprise(adr.formatted_address);
  };

  const getImageFile = (image) => {
    setImageFile(image);
  };
  const handleSubmit = (e) => {
    let canSubmit = true;

    setENomEvent(false);
    setETypeEvent(false);
    setESecteurEvent(false);
    setEDescriptionEvent(false);
    setEDateDebut(false);
    setEPrixEvent(false);
    setEAddress(false);
    setEDateFin(false);
    setEMaxPlace(false);

    if (!adress) {
      setEAddress(true);
      canSubmit = false;
    }
    if (nomEvent === "") {
      setENomEvent(true);
      canSubmit = false;
    }
    if (typeEvent === "") {
      setETypeEvent(true);
      canSubmit = false;
    }
    if (secteur === "") {
      setESecteurEvent(true);
      canSubmit = false;
    }
    if (description === "") {
      setEDescriptionEvent(true);
      canSubmit = false;
    }
    if (dateDebut.length === 0) {
      setEDateDebut(true);
      canSubmit = false;
    }
    if (dateFin.length === 0) {
      setEDateFin(true);
      canSubmit = false;
    }
    if (duration === "") {
      setEDurationEvent(true);
      canSubmit = false;
    }
    if (prix === "") {
      setEPrixEvent(true);
      canSubmit = false;
    }
    if (maxPlace === "") {
      setEMaxPlace(true);
      canSubmit = false;
    }

    if (canSubmit) {
      const Event = new Parse.Object.extend("Annonce");
      const event = new Event();

      const user = Parse.User.current();

      event.set("userId", user);
      const point = new Parse.GeoPoint(coords.lat, coords.lng);
      event.set("auteur", user.get("username"));
      event.set("titre", nomEvent);
      event.set("typeContrat", typeEvent);
      event.set("virtuel", false);
      event.set("adresse", adress.formatted_address);
      event.set("secteur", secteur);
      event.set("resume", description);
      event.set("dateDebut", startDate);
      event.set("dateFin", endDate);
      event.set("type", "event");
      event.set("tarif", parseInt(prix));
      event.set("nbInscritMax", parseInt(maxPlace));
      if (imageFile) {
        const iconImageFile = new Parse.File("event", imageFile);
        event.set("logoEnterprise", iconImageFile);
      }
      event.set("listUser", []);
      event.set("listFavUser", []);
      event.set("nbInscrit", 0);
      event.set("visible", true);
      event.set("position", point);

      adress.address_components.map((address) => {
        if (address.types[0] === "locality") {
          event.set("ville", address.long_name);
        }
        if (address.types[0] === "country") {
          event.set("country", address.long_name);
        }
        if (address.types[0] === "postal_code") {
          event.set("codePostal", address.long_name);
        }
      });

      event.save().then(
        (event) => {
          navigate("/Events");
        },
        (error) => {
          alert("Error: " + error.code + " " + error.message);
        }
      );
    }
  };

  useEffect(() => {}, [typeEvent]);

  return (
    <Box>
      <Flex>
        <Grid gutter="lg" w={"100%"}>
          <Grid.Col order={2} key="1" xs={12} sm={12} md={8} lg={8} xl={8}>
            <Box bg="white" w="100%" borderRadius="20px">
              <ShowEvent
                imageFile={imageFile}
                nomEvent={nomEvent}
                typeEvent={typeEvent}
                secteur={secteur}
                description={description}
                dateDebut={
                  moment(dateDebut).locale("fr").format("LLLL") ==
                  "Invalid date"
                    ? dateDebut
                    : moment(dateDebut).locale("fr").format("LLLL")
                }
                dateFin={
                  moment(dateFin).locale("fr").format("LLLL") == "Invalid date"
                    ? dateFin
                    : moment(dateFin).locale("fr").format("LLLL")
                }
                month={
                  moment(dateDebut).locale("fr").format("LLLL") ==
                  "Invalid date"
                    ? dateDebut
                    : moment(dateDebut).locale("fr").format("MM")
                }
                lieu={adresseEntreprise}
                prix={prix}
              />
            </Box>
          </Grid.Col>

          <Grid.Col
            order={1}
            orderLg={2}
            key="2"
            xs={12}
            sm={12}
            md={4}
            lg={4}
            xl={4}
          >
            <Box
              boxShadow="lg"
              ms={["0px", "0px", "0px", "0px"]}
              bg="#d4eeff"
              w="100%"
              height={["", "", "740px", "740px"]}
              p={4}
              borderRadius="20px"
            >
              <Flex>
                <Text
                  fontFamily={"Sofia Pro"}
                  fontSize={"24px"}
                  fontWeight={"bold"}
                >
                  {title}
                </Text>
                <Spacer></Spacer>
                <Box align={"center"} my={1} pr={4}>
                  <UploadImage getImageFile={getImageFile}></UploadImage>
                </Box>
              </Flex>

              <FormControl isInvalid={eNomEvent}>
                <Input
                  mt={"10px"}
                  bg="white"
                  id="Nom de l'offre"
                  borderRadius="20px"
                  fontFamily={"Sofia Pro"}
                  fontSize={"14px"}
                  placeholder="Nom de l'événement"
                  value={nomEvent}
                  onChange={(e) => setNomEvent(e.target.value)}
                  isInvalid={eNomEvent}
                />
                {!eNomEvent ? "" : ""}
              </FormControl>

              <SimpleGrid mt={"4px"} columns={2} py={1}>
                <FormControl isInvalid={eTypeEvent}>
                  <Select
                    radius="20px"
                    placeholder="Type d'événement"
                    searchable
                    onSearchChange={setTypeEvent}
                    searchValue={typeEvent}
                    nothingFound="No options"
                    data={event_type}
                  />
                  {!eTypeEvent ? "" : ""}
                </FormControl>
                <FormControl isInvalid={eSecteurEvent}>
                  <Select
                    radius="20px"
                    placeholder="Secteur d'activité"
                    searchable
                    onSearchChange={setSecteurEvent}
                    searchValue={secteur}
                    nothingFound="No options"
                    data={work_domaine}
                  />
                  {!eSecteurEvent ? "" : ""}
                </FormControl>
              </SimpleGrid>

              <FormControl isInvalid={eDescriptionEvent}>
                <Textarea
                  resize="None"
                  my={"4px"}
                  bg="white"
                  fontFamily={"Sofia Pro"}
                  fontSize={"14px"}
                  borderRadius="20px"
                  placeholder="Description de l'événement"
                  value={description}
                  onChange={(e) => setDescriptionEvent(e.target.value)}
                />
                {!eDescriptionEvent ? "" : ""}
              </FormControl>

              <FormControl isInvalid={eMaxPlace}>
                <Input
                  mt={"4px"}
                  bg={"white"}
                  borderRadius="20px"
                  fontFamily={"Sofia Pro"}
                  fontSize={"14px"}
                  placeholder="Max place disponible"
                  value={maxPlace}
                  onChange={(e) => setMaxPlace(e.target.value)}
                  isInvalid={eMaxPlace}
                  type="number"
                />
                {!eMaxPlace ? "" : ""}
              </FormControl>

              <SimpleGrid columns={[1, 1, 2]} spacing={10}>
                <Box>
                  <FormControl isInvalid={eDateDebut} my={1}>
                    <Input
                      mt={"4px"}
                      bg={"white"}
                      borderRadius="20px"
                      fontFamily={"Sofia Pro"}
                      fontSize={"14px"}
                      placeholder="Select Date and Time"
                      size="md"
                      type="date"
                      selected={startDate}
                      onChange={(e) => {
                        setDateDebut(e.target.value.toString());
                        setStartDate(new Date(e.target.value));
                      }}
                    />{" "}
                    {!eDateDebut ? "" : ""}
                  </FormControl>
                </Box>
                <Box>
                  <FormControl isInvalid={eDateFin} my={1}>
                    <Input
                      mt={"4px"}
                      bg={"white"}
                      borderRadius="20px"
                      fontFamily={"Sofia Pro"}
                      fontSize={"14px"}
                      placeholder="Select Date and Time"
                      size="md"
                      type="date"
                      selected={endDate}
                      onChange={(e) => {
                        setDateFin(e.target.value.toString());
                        setEndDate(new Date(e.target.value));
                      }}
                    />{" "}
                    {!eDateFin ? "" : ""}
                  </FormControl>
                </Box>
              </SimpleGrid>

              <FormControl isInvalid={eAdress}>
                <SearchLocationInput
                  my={"4px"}
                  bg={"white"}
                  borderRadius="20px"
                  fontSize={"14px"}
                  fontFamily={"Sofia Pro"}
                  getAddress={getAddress}
                  getCoords={getCoords}
                  typeAnnonce="de l'événement"
                ></SearchLocationInput>
                {!eAdress ? "" : ""}
              </FormControl>

              <FormControl isInvalid={ePrixEvent}>
                <Input
                  my={"4px"}
                  bg={"white"}
                  borderRadius="20px"
                  fontFamily={"Sofia Pro"}
                  fontSize={"14px"}
                  placeholder="Prix de l'événement"
                  value={prix}
                  type="number"
                  onChange={(e) => setPrixEvent(e.target.value)}
                  isInvalid={ePrixEvent}
                />
                {!ePrixEvent ? "" : ""}
              </FormControl>

              <Box>
                <Button
                  mt={["40px", "40px", "", ""]}
                  py={4}
                  bg="#F1404B"
                  borderRadius="20px"
                  fontFamily={"Sofia Pro"}
                  fontSize={"14px"}
                  color={"white"}
                  position={["", "", "absolute", "absolute"]}
                  bottom={["", "", "40px", "40px"]}
                  errorBorderColor="red.300"
                  onClick={handleSubmit}
                >
                  Valider
                </Button>
              </Box>
            </Box>
          </Grid.Col>
        </Grid>
      </Flex>
    </Box>
  );
};
